import {
  AgentBreadcrumbs,
  type AgentBreadcrumbItem,
} from "@/pages/agent/components/agent-breadcrumbs";

type BreadcrumbProject = {
  id: string;
  title: string | null | undefined;
};

export const AgentProjectBreadcrumbs = ({
  currentPage,
  parentProject,
  project,
  onOpenProject,
  onOpenProjects,
}: {
  currentPage?: string;
  parentProject?: BreadcrumbProject;
  project: BreadcrumbProject;
  onOpenProject: ({ projectId }: { projectId: string }) => void;
  onOpenProjects: () => void;
}) => {
  const items: AgentBreadcrumbItem[] = [{ label: "Projects", onClick: onOpenProjects }];

  if (parentProject) {
    items.push({
      label: parentProject.title || "Untitled project",
      onClick: () => onOpenProject({ projectId: parentProject.id }),
    });
  }

  if (currentPage) {
    items.push({
      label: project.title || "Untitled project",
      onClick: () => onOpenProject({ projectId: project.id }),
    });
    items.push({ label: currentPage });
  } else {
    items.push({ label: project.title || "Untitled project" });
  }

  return <AgentBreadcrumbs items={items} />;
};
